import { Alert, Form, Select } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { SystemDescriptions } from "src/common/descriptions/descriptions"
import { Patient } from "src/common/models/patient"
import { PageCard } from "src/common/styles/styles"
import { filterOption } from "src/common/util"
import InnerLoader from "src/components/innerLoader"
import { getPatientByIdApi } from "src/features/MedicalArea/state/action"
import { CREATE_MEDICAL_PAYMENT_API, GET_PATIENT_BY_ID_API, GET_PATIENTS_API } from "src/features/MedicalArea/state/actionTypes"
import { MedicalAreaError, MedicalAreaErrorOrigin } from "src/features/MedicalArea/state/types"
import { RootState } from "src/state/reducer"
import dayjs from 'dayjs'
import { SystemConstants } from "src/common/constants"

interface ReduxProps {
    patients: Patient[]
    error?: MedicalAreaError
    isGettingPatients: boolean
    isGettingPatientById: boolean
    currentPatient?: Patient
    isCreatingPayment: boolean
    createPaymentSuccess: boolean
}

interface Props {
    onPatientChange: (patient?: Patient) => void
}

export const SelectionSearch = (props: Props) => {
    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        patients: state.medicalArea.patients,
        error: state.medicalArea.error,
        isGettingPatientById: serviceLoading(state, [GET_PATIENT_BY_ID_API]),
        isGettingPatients: serviceLoading(state, [GET_PATIENTS_API]),
        currentPatient: state.medicalArea.currentPatient,
        isCreatingPayment: serviceLoading(state, [CREATE_MEDICAL_PAYMENT_API]),
        createPaymentSuccess: state.medicalArea.createMedicalPaymentSuccess,
    }))

    const [form] = Form.useForm();

    const descriptions = SystemDescriptions.COMPONENTS.PATIENT_SEARCH

    const handlePatientChange = (value: string) => {
        props.onPatientChange(undefined)

        form.setFieldsValue({
            paymentPlanId: undefined,
            description: undefined,
            cash: 0,
            card: 0,
        })

        dispatch(getPatientByIdApi(parseInt(value), { populated: "1" }))
    }

    return (
        <PageCard
            size="small"
            title={descriptions.PERSONAL_DATA.CUSTOMER.PLACEHOLDER}
        >
            {
                reduxProps.isGettingPatients
                    ? <InnerLoader />
                    : reduxProps.error && reduxProps.error.type === MedicalAreaErrorOrigin.GET_PATIENTS
                        ? <Alert type="error" message={"Error"} banner />
                        :
                        <Select
                            style={{ width: '100%' }}
                            showSearch
                            placeholder={descriptions.PERSONAL_DATA.CUSTOMER.PLACEHOLDER}
                            optionFilterProp="children"
                            onChange={handlePatientChange}
                            filterOption={filterOption}
                            options={reduxProps.patients.map(patient => ({
                                value: `${patient.id_patient ?? 0}`,
                                label: `${patient.name} ${patient.surname} - ${dayjs(patient.birthdate).format(SystemConstants.DATE_FORMAT)} - ${patient.doc_id}`,
                            }))}
                        />
            }
        </PageCard>
    )
}
